import React from 'react';
import { motion } from 'framer-motion';
export function WhyPeopleBook() {
  const customEase = [0.16, 1, 0.3, 1];
  const benefits = [{
    title: 'Learn Practical, Usable Techniques',
    description: 'No fluff or trends you never use. Just real world techniques you can apply every day.'
  }, {
    title: 'Build Real Confidence with Makeup',
    description: 'Leave feeling empowered and capable, not overwhelmed or intimidated.'
  }, {
    title: 'Understand Products That Work for You',
    description: "Learn which products suit your skin, budget, and lifestyle—not just what's trending."
  }, {
    title: 'Get Hands-On Guidance',
    description: "This isn't watching a screen. It's learning by doing, with expert feedback in real time."
  }, {
    title: 'Enjoy a Premium, Curated Experience',
    description: 'Small class sizes, thoughtful teaching, and an environment designed for learning.'
  }, {
    title: 'Learn from Proven Experience',
    description: 'Taught by a trainer who delivered 360+ sessions last year—not just theory, but practice.'
  }];
  return <section className="py-24 md:py-32 lg:py-40 bg-parchment relative overflow-hidden texture-grain" data-id="element-360">
      <div className="max-w-[90rem] mx-auto px-6 lg:px-12" data-id="element-361">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24" data-id="element-362">
          {/* Left Column - Editorial Statement */}
          <div className="w-full lg:w-[45%] relative" data-id="element-363">
            <div className="sticky top-32" data-id="element-364">
              <motion.h2 initial={{
              opacity: 0,
              x: -30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 1,
              ease: customEase
            }} className="font-serif text-5xl md:text-7xl font-light text-ink leading-[1.1] relative z-10" data-id="element-365">
                Why Thousands Choose to Learn{' '}
                <span className="italic font-medium relative" data-id="element-366">
                  In Person
                  {/* SVG Accent behind 'In Person' */}
                  <svg className="absolute -bottom-2 left-0 w-full h-4 text-copper opacity-40 -z-10" viewBox="0 0 100 20" preserveAspectRatio="none" data-id="element-367">
                    <path d="M0 15 Q 50 0 100 15" fill="none" stroke="currentColor" strokeWidth="3" data-id="element-368" />
                  </svg>
                </span>
              </motion.h2>

              {/* Decorative Editorial Image */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 1,
              delay: 0.3,
              ease: customEase
            }} className="hidden lg:block mt-12 w-full h-[500px] relative rounded-sm overflow-hidden" data-id="element-369">
                <img src="https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=800&q=80" alt="Makeup products in warm light" className="w-full h-full object-cover img-editorial" data-id="element-370" />
                <div className="warm-overlay" data-id="element-371"></div>
              </motion.div>
            </div>
          </div>

          {/* Right Column - Numbered List */}
          <div className="w-full lg:w-[55%]" data-id="element-372">
            <div className="flex flex-col space-y-16" data-id="element-373">
              {benefits.map((benefit, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 40,
              x: index % 2 === 0 ? -20 : 20
            }} whileInView={{
              opacity: 1,
              y: 0,
              x: 0
            }} viewport={{
              once: true,
              margin: '-100px'
            }} transition={{
              duration: 1,
              delay: index * 0.1,
              ease: customEase
            }} className="relative pl-16 md:pl-24" data-id="element-374">
                  <span className="absolute left-0 top-0 font-serif text-4xl md:text-5xl font-light text-copper opacity-50" data-id="element-375">
                    0{index + 1}
                  </span>
                  <h3 className="font-serif text-2xl md:text-3xl font-semibold text-ink mb-4" data-id="element-376">
                    {benefit.title}
                  </h3>
                  <p className="font-sans text-stone text-lg leading-relaxed max-w-md" data-id="element-377">
                    {benefit.description}
                  </p>
                </motion.div>)}

              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.8,
              delay: 0.6,
              ease: customEase
            }} className="pt-12 border-t border-cream-dark" data-id="element-378">
                <h3 className="font-serif text-2xl italic text-ink mb-6" data-id="element-379">
                  Ready to experience it for yourself?
                </h3>
                <a href="#masterclasses" className="inline-block text-xs uppercase tracking-[0.2em] text-ink hover:text-copper transition-colors border-b border-ink hover:border-copper pb-1 font-semibold" data-id="element-380">
                  Book a Masterclass &rarr;
                </a>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}